import { inject, Injectable } from '@angular/core';
import { AlertService } from './alert.service';
import { UserFriendlyException } from '../models/auth.models';

@Injectable({
  providedIn: 'root'
})
export class ExceptionService {

  private _alertService: AlertService = inject(AlertService);

  public emitUserFriendlyException(exception: UserFriendlyException): void {
    this._alertService.showToast('red', exception.message, 10000);
  }
}